import { useCallback, useMemo, useState } from 'react';

import { AppDispatch } from 'store/store';
import { Organizer } from '../../../domain/interfaces/organizer';
import UDButton from 'ud-ui/components/button';
import UDInput from 'ud-form/components/input/component';
import UDText from 'ud-ui/components/text';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import { topupBalance } from '../../../store/actions';
import { baseApi } from 'shared/api/base-api';
import { useDispatch } from 'react-redux';
import Modal from 'ud-ui/components/modal';

interface IProps {
  organizer: Organizer | undefined;
}

function Balance(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { organizer } = props;
  // const { open, close, Modal } = useModal();
  const [amount, setAmount] = useState<number>(0);

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setAmount(0);
    open();
  }, [open]);

  const handleTopup = useCallback(() => {
    if (!organizer?.adminUser?.id) {
      toast.error('Не определить пользователя');
      console.error({
        message: "Can't identify user",
        adminUser: organizer?.adminUser,
        organizer,
      });
      return;
    }

    if (amount <= 0) {
      toast.error('Сумма должна быть больше 0');
      return;
    }

    dispatch(
      topupBalance({
        amount,
        recipientId: organizer?.adminUser?.id,
        tournamentId: organizer.id,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(baseApi.util.invalidateTags([{ type: 'Organizer', id: organizer.id }]));
        close();
      });
  }, [amount, close, dispatch, organizer]);

  const balance = useMemo(() => {
    return organizer?.adminUser?.balance ? (organizer?.adminUser?.balance / 100).toFixed(2) : '0.00';
  }, [organizer]);

  return (
    <>
      <div className={'flex items-center'} style={{ gap: 20 }}>
        <UDText type={'subhead'}>Баланс: {balance} руб.</UDText>
        <UDButton style={{ height: 36 }} disabled={!organizer} onClick={handleOpen} type={'button'} variant={'primary'}>
          Пополнить баланс
        </UDButton>
      </div>

      <Modal show={isOpen} onClose={close}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleTopup();
          }}
        >
          <Modal.Body>
            <UDText className={'mb-1'} type={'headline'}>
              Пополнить баланс
            </UDText>
            <UDText className="mb-4" type={'subhead'}>
              Текущий баланс: {balance} руб.
            </UDText>
            <div className={'flex items-center w-full'} style={{ gap: 20 }}>
              <UDText type={'subhead'} style={{ textWrap: 'nowrap' }}>
                Сумма в рублях
              </UDText>
              <UDInput
                autoFocus
                style={{ backgroundColor: '#F2F2F2' }}
                wrapperProps={{ className: classNames('w-full') }}
                placeholder={'Введите сумму'}
                value={amount}
                onChange={(event) => setAmount(Number(event.target.value))}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <UDButton onClick={close} variant={'secondary'} stretch>
              Отменить
            </UDButton>
            <UDButton onClick={handleTopup} variant={'primary'} stretch>
              Пополнить
            </UDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default Balance;
